import { render, staticRenderFns } from "./raditubeLogo.vue?vue&type=template&id=b594e86e&scoped=true&"
import script from "./raditubeLogo.vue?vue&type=script&lang=js&"
export * from "./raditubeLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b594e86e",
  null
  
)

export default component.exports